import { render, staticRenderFns } from "./DeleteConsultantModal.vue?vue&type=template&id=49c863a9&scoped=true"
import script from "./DeleteConsultantModal.vue?vue&type=script&lang=js"
export * from "./DeleteConsultantModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteConsultantModal.vue?vue&type=style&index=0&id=49c863a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c863a9",
  null
  
)

export default component.exports